/**
 * 取稿需要下载图片弹窗
 */
"use strict";
angular.module("resTakeDraftDownloadImgsModule", []).controller("resTakeDraftDownloadImgsCtrl", ["$scope", "$q", "trsHttpService", "$modalInstance", "$interval", "basicParams", "modalDialog",
    function($scope, $q, trsHttpService, $modalInstance, $interval, basicParams, modalDialog) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                loadingWdith: 0, // loading的进度
                isShowLoading: false,
                hasImgDownload: true,
                imgCount: 0, // 下载的图片总数
                loadingInterval: "",
                title: basicParams.TITLE,
                issuccess: 'false'
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            $scope.data = {
                lists: basicParams.REPORTS,
                fatherParams: basicParams.fatherParams
            };
            var nextArr = [],
                imgCount = 0;
            for (var i = 0; i < $scope.data.lists.length; i++) {

                if ($scope.data.lists[i].PICERROR == 1) {
                    $scope.data.lists[i].TITLE = JSON.parse($scope.data.lists[i].TITLE);
                    nextArr.push($scope.data.lists[i].TITLE.GUID);
                    $scope.status.hasImgDownload = true;
                    imgCount += $scope.data.lists[i].TITLE.PICCOUNT;
                }
            }
            $scope.status.imgCount = imgCount;
            $scope.data.fatherParams.guid = nextArr.join();
        }

        /**
         * [cancle description] 取消取稿
         * @return {[type]} [description]
         */
        $scope.cancle = function() {
            $interval.cancel($scope.status.loadingInterval);
            $modalInstance.dismiss();
        };

        /**
         * [downloadImages description] 下载图片
         * @return {[type]} [description]
         */
        $scope.downloadImages = function() {
            $scope.status.loadingWdith = 0;
            $scope.status.isShowLoading = true;
            var step = 100 / 30,
                n = 0,
                params = {
                    serviceid: "mlf_bigdataexchange",
                    methodname: "picsDownloadStatus",
                    PaperPubDate: $scope.data.fatherParams.PaperPubDate,
                    guid: $scope.data.fatherParams.guid,
                    channelName: $scope.data.fatherParams.channelName,
                    indexName: $scope.data.fatherParams.indexName,
                    nodeId: $scope.data.fatherParams.nodeId
                };
            $scope.status.loadingInterval = $interval(function() {
                $scope.status.loadingWdith += step;
                n++;
                if (n % 10 == 0) {
                    // 10s发送请求，判断图片是否下载成功，下载成功后调用取稿接口
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                        var flag = true;
                        for (var key in data) {
                            if (data[key] == "false") {
                                flag = false;
                                break;
                            }
                        }
                        if (flag) {
                            $scope.status.loadingWdith = 99;
                            $interval.cancel($scope.status.loadingInterval);
                            $scope.status.isShowLoading = false;
                            $scope.status.showDownload = false;
                            takeDraft($scope.data.fatherParams);
                        }
                    });
                }
                if ($scope.status.loadingWdith > 99) {
                    $scope.status.loadingWdith = 99;
                    $interval.cancel($scope.status.loadingInterval);
                    $scope.status.isShowLoading = false;
                    $scope.status.showDownload = false;
                    takeDraft($scope.data.fatherParams);
                }
            }, 1000);
        };

        /**
         * [goOnTakeDraft description] 继续取稿
         * @return {[type]} [description]
         */
        $scope.goOnTakeDraft = function() {
            $interval.cancel($scope.status.loadingInterval);
            $scope.status.isShowLoading = false;
            var params = { CHECKPIC: false }; // 是否忽略未下载图片继续取稿
            params = angular.extend(params, $scope.data.fatherParams);
            takeDraft(params);
        };

        /**
         * [takeDraft description] 取稿方法
         * @return {[type]} [description]
         */
        function takeDraft(params) {
            var deferred = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                $scope.status.issuccess = data.ISSUCCESS;
                if (data.ISSUCCESS == 'true') {
                    modalDialog.alertType($scope.status.title + "成功!", "", "success", false, function() {
                        $scope.status.showDownload = false;
                        deferred.resolve(data);
                        $modalInstance.close(data);
                    });
                } else {
                    var flag = false,
                        imgCount = 0,
                        guidArr = [];
                    for (var i = 0; i < data.REPORTS.length; i++) {
                        if (data.REPORTS[i].PICERROR == 1) {
                            data.REPORTS[i].TITLE = JSON.parse(data.REPORTS[i].TITLE);
                            guidArr.push(data.REPORTS[i].TITLE.GUID);
                            flag = true;
                            imgCount += parseInt(data.REPORTS[i].TITLE.PICCOUNT);
                        }
                    }
                    $scope.data.lists = data.REPORTS;
                    $scope.status.imgCount = imgCount;
                    $scope.data.fatherParams.guid = guidArr.join();
                    $scope.status.hasImgDownload = flag;
                }
            }, function() {
                $modalInstance.dismiss();
            });
        }
    }
]);